export default {
  CA: '(877) 798-3752',
  MX: '01 800 228 8145',
  US: '(877) 798-3752',
};
